import { render, staticRenderFns } from "./DefectGroups.vue?vue&type=template&id=09a63981"
import script from "./DefectGroups.vue?vue&type=script&lang=js"
export * from "./DefectGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports